import { render, staticRenderFns } from "./RegisterUserView.vue?vue&type=template&id=101ac168&"
import script from "./RegisterUserView.vue?vue&type=script&lang=js&"
export * from "./RegisterUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports